import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-move-members": "",
  class: "space-y-4"
}
const _hoisted_2 = {
  key: 0,
  class: "m-0 text-sm leading-relaxed text-gray-600"
}

import { computed, ref } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import TheModal from '@/components/TheModal.vue'
import { provideHighlightTerms } from '@/composables/useHighlightTerms'
import { useToast } from '@/composables/useToast'
import api from '@/store/api'


export default {
  __name: 'MoveMembersModal',
  props: {
  open: { type: Boolean, default: false },
  tierId: { type: String, required: true },
  tierName: { type: String, default: '' },
  tiers: { type: Array, default: () => [] }
},
  emits: ['close', 'moved'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { showToast } = useToast()
const moveTo = ref(null)
const moving = ref(false)

const tierLabel = computed(() => props.tierName.trim() || 'this membership')
const target = computed(() => props.tiers.find(tier => tier.id === moveTo.value) ?? null)
const consequence = computed(
  () =>
    `Every member of ${tierLabel.value} moves to ${target.value.name}. ` +
    `Their ${tierLabel.value} repeat orders, membership fees and meal plan stop, ` +
    `and the ${target.value.name} settings apply from now on.`
)

provideHighlightTerms(computed(() => [props.tierName, target.value?.name]))

const close = () => {
  if (moving.value) return
  moveTo.value = null
  emit('close')
}

const move = async () => {
  if (!target.value || moving.value) return
  moving.value = true
  try {
    await api.call('POST', `membership_tiers/${props.tierId}/move?move_to_id=${target.value.id}`)
    showToast(`Members moved to ${target.value.name}`)
    moving.value = false
    emit('moved')
    close()
  } catch {
    showToast('Moving the members failed. Refresh the page to see who moved.', { type: 'error' })
    moving.value = false
  }
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")

  return (_openBlock(), _createBlock(TheModal, {
    "is-open": __props.open,
    "modal-title": `Move every member of ${tierLabel.value}`,
    "max-width": "max-w-md",
    onCloseModal: close
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SelectInput, {
          "model-value": moveTo.value,
          name: "Move them to",
          placeholder: "Pick a membership",
          options: __props.tiers.map(tier => ({ name: tier.name, value: tier.id })),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (moveTo.value = $event))
        }, null, 8, ["model-value", "options"]),
        (target.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createVNode(_unref(HighlightedText), { text: consequence.value }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_NeueButton, {
        type: "secondary",
        onClick: close
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_NeueButton, {
        disabled: !target.value,
        loading: moving.value,
        onClick: move
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Move members", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    _: 1
  }, 8, ["is-open", "modal-title"]))
}
}

}